// extracted by mini-css-extract-plugin
export default {"title":"export-suppression-modal_title__uLhXy","buttonsWrapper":"export-suppression-modal_buttonsWrapper__nyWIi"};